//CONSTANTS
import appConstants from "../_constants/appConstants";
import { createToast } from "../_utils";
/* ---------------------------------------------------
 MINIMIZE SIDEBAR
----------------------------------------------------- */
export const minimizeSidebar = payload => ({
  type: appConstants.MINIMIZE_SIDEBAR,
  payload
});

/* ---------------------------------------------------
 COLLAPSE SIDEBAR
----------------------------------------------------- */
export const collapseSidebar = payload => ({
  type: appConstants.COLLAPSE_SIDEBAR,
  payload
});

/* ---------------------------------------------------
 TOGGLE RIGHTBAR
----------------------------------------------------- */
export const toggleRightbar = payload => ({
  type: appConstants.TOGGLE_RIGHTBAR,
  payload
});

/* ---------------------------------------------------
 TOGGLE FIXED FOOTER
----------------------------------------------------- */
export const toggleFixedFooter = payload => ({
  type: appConstants.TOGGLE_FIXED_FOOTER,
  payload
});

/* ---------------------------------------------------
 TOGGLE COLLAPSED FOOTER
----------------------------------------------------- */
export const toggleCollapsedFooter = payload => ({
  type: appConstants.TOGGLE_COLLAPSED_FOOTER,
  payload
});

/* ---------------------------------------------------
 UPDATE PAGE HEADER
----------------------------------------------------- */
export const updatePageHeader = payload => ({
  type: appConstants.UPDATE_PAGE_HEADER,
  payload
});

/* ---------------------------------------------------
 UPDATE BREADCRUMB MENU ITEMS
----------------------------------------------------- */
export const updateBreadcrumbMenuItems = payload => ({
  type: appConstants.UPDATE_BREADCRUMB_MENU_ITEMS,
  payload
});
/* ---------------------------------------------------
 SHOW TOAST
----------------------------------------------------- */
export const showToast = (options = {}) => ({
  type: appConstants.SHOW_TOAST,
  payload: createToast(options)
});
/* ---------------------------------------------------
 HIDE TOAST
----------------------------------------------------- */
export const hideToast = id => ({
  type: appConstants.HIDE_TOAST,
  payload: id
});



// WEBPACK FOOTER //
// ./src/_actions/appActions.js